import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClass, KiloClassWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateKiloClass(): UseMutationResult<
  AxiosResponse<KiloClass>,
  AxiosError<ErrorMessage>,
  KiloClassWrite
> {
  const queryClient = useQueryClient();

  const createKiloClass = (kiloClass: KiloClassWrite): Promise<AxiosResponse<KiloClass>> => {
    return client.post('kilo-classes/', kiloClass);
  };

  return useMutation(createKiloClass, {
    onSuccess: () => {
      queryClient.invalidateQueries('classes');
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries(['workouts', 'calendar']);
    },
  });
}
